import * as React from 'react';
import { useTranslate } from '@tolgee/react';

const SUPPORT_URL =
  'https://abinbevww.service-now.com/abiex?id=sc_cat_item&sys_id=5ad2235adb1cc050f17eb29f29961934';

function HelpCenterPopupContent(): React.ReactElement {
  const { t } = useTranslate();

  return (
    <>
      <p className="mb-1 text-sm font-semibold text-white">
        {t('helpCenter.title', 'Having trouble with the platform?')}
      </p>
      <p className="mb-3 text-xs text-gray-300">
        {t(
          'helpCenter.description',
          "If something isn't working as expected or you need to report a technical incident, please open a ticket here:"
        )}
      </p>
      <a
        href={SUPPORT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block w-full rounded-md bg-white px-3 py-1.5 text-center text-xs font-semibold text-gray-900 transition-colors hover:bg-gray-100">
        {t('helpCenter.supportLink', 'Support Link')}
      </a>
    </>
  );
}

export function HelpCenterBar(): React.ReactElement {
  const [open, setOpen] = React.useState(false);
  const closeTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const { t } = useTranslate();

  const openPopup = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
    setOpen(true);
  };

  const scheduleClose = () => {
    closeTimer.current = setTimeout(() => setOpen(false), 150);
  };

  return (
    <div className="relative mt-auto px-2 pb-3">
      <button
        type="button"
        aria-label={t('helpCenter.label', 'Help Center')}
        onMouseEnter={openPopup}
        onMouseLeave={scheduleClose}
        className="flex h-9 w-9 items-center justify-center rounded-full bg-yellow-400 text-gray-900 transition-colors hover:bg-yellow-300">
        <span className="text-sm font-bold">?</span>
      </button>
      {open && (
        <div
          onMouseEnter={openPopup}
          onMouseLeave={scheduleClose}
          className="absolute bottom-0 left-full z-50 ml-2 w-64 rounded-lg bg-gray-900 p-4 shadow-xl">
          <HelpCenterPopupContent />
        </div>
      )}
    </div>
  );
}

export function HelpCenterContent(): React.ReactElement {
  const [open, setOpen] = React.useState(false);
  const closeTimer = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const { t } = useTranslate();

  const openPopup = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
    setOpen(true);
  };

  const scheduleClose = () => {
    closeTimer.current = setTimeout(() => setOpen(false), 150);
  };

  return (
    <div className="relative flex-shrink-0 border-t border-yellow-300 bg-yellow-400 px-4 py-3">
      <button
        type="button"
        onMouseEnter={openPopup}
        onMouseLeave={scheduleClose}
        className="flex w-full items-center justify-center gap-2 text-sm font-semibold text-gray-900 transition-opacity hover:opacity-80">
        <span className="text-sm font-bold">?</span>
        {t('helpCenter.label', 'Help Center')}
        <span>›</span>
      </button>
      {open && (
        <div
          onMouseEnter={openPopup}
          onMouseLeave={scheduleClose}
          className="absolute bottom-0 left-full z-50 ml-2 w-64 rounded-lg bg-gray-900 p-4 shadow-xl">
          <HelpCenterPopupContent />
        </div>
      )}
    </div>
  );
}
